export function isValidEmail(email: string): boolean {
    // Simple RFC 5322 compliant regex for email validation
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailPattern.test(email);
}
